if (!customElements.get('product-options')) {
  customElements.define(
    'product-options',
    class ProductOptions extends window.BAO.CustomElement {
      constructor() {
        super()

        this.triggerEls = this.querySelectorAll(
          '[data-el="product-options.trigger"]',
        )
        this.titleEls = this.querySelectorAll('[data-el="product-options.title"]')
        this.selectEls = this.querySelectorAll('[data-el="product-options.select"]')

        if (this.triggerEls.length < 2) return

        this.initialiseOptionButtons()

      }

      initialiseOptionButtons() {
        this.triggerEls.forEach(triggerEl => {
          triggerEl.addEventListener('click', this.handleTrigger.bind(this))
        })
      }

      handleTrigger = event => {
        const optionIndex = event.target.dataset.index
        const optionValue = event.target.dataset.value
        const optionTitle = event.target.dataset.title

        this.triggerEls.forEach(triggerEl => {
          if (triggerEl.dataset.index === optionIndex) {
            triggerEl.setAttribute('aria-pressed', triggerEl === event.target)
          }
        })

        this.selectEls.forEach(selectEl => {
          if (selectEl.dataset.index === optionIndex) {
            selectEl.value = optionValue

            selectEl.dispatchEvent(new Event('change', {
              bubbles: true
            }))
          }
        })

        this.titleEls.forEach(titleEl => {
          if (titleEl.dataset.index === optionIndex) {
            titleEl.innerHTML = optionTitle
          }
        })
      }
    },
  )
}